import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime)

export const getRelativeTimeFormat = (date: string) => {
  return dayjs(date).fromNow()
}
